const React = require("react");
const { usePrintful } = require("../context/PrintfulContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const DropshippingImportedProducts = () => { const { t } = usePrintful(); return h(ProductCollectionPage, { imported: true, title: t("h_pf_imported_products", "Imported Printful products"), description: t("h_pf_imported_products_desc", "Products already linked to your Elakay shop.") }); };
module.exports = { DropshippingImportedProducts };
